// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1gjnQ","gfeWrapper":"CalendarEvent_gfeWrapper__1Woml"};